import { Configuration2D } from '../../../../models/configurators-2d/configuration2d';
import { BaseAppService } from '../../../../services/configurators-2d/base-app-service';
import { IPreview } from './i-preview';
import { BaseItem } from '../base-item';

export abstract class PreviewItem<C extends Configuration2D, S extends BaseAppService<C>>
  extends BaseItem<C, S>
  implements IPreview
{
  constructor(appService: S) {
    super(appService);

    // update au resize de la fenêtre
    window.addEventListener('resize', async event => {
      await this.update();
    });
  }

  abstract update(): Promise<void>;
}
